var ResponsiveMenu = (function () {
  function init() {
    $('#nav').addClass('collapsed').before('<div id="menu"><span class="fa fa-bars"></span> Menu</div>');
    $('#menu').click(function () {
      $('#nav').slideToggle('fast');
    });
    $(window).resize(function () {
      if (window.innerWidth > 641) {
        $('#nav').removeAttr('style');
      }
    });
  }

  return {
    init: init
  };
})();

$(function () { ResponsiveMenu.init(); });



// WEBPACK FOOTER //
// ./javascripts/components/legacy/responsive-menu.js